"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAdvertisementUpdateInputSchema = exports.APosAdvertisementCreateInputSchema = exports.APosAdvertisementSchema = exports.APosAdTypeSchema = exports.APosAdStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAdStatusSchema = zod_1.z.enum(['draft', 'active', 'paused', 'expired', 'archived']);
exports.APosAdTypeSchema = zod_1.z.enum(['image', 'video', 'html']);
exports.APosAdvertisementSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    advertisementId: id_schema_1.EntityIdSchema,
    advertiserId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    description: zod_1.z.string().max(500).optional(),
    adType: exports.APosAdTypeSchema,
    mediaUrl: zod_1.z.string().url(),
    mediaKey: zod_1.z.string().optional(),
    thumbnailUrl: zod_1.z.string().url().optional(),
    clickUrl: zod_1.z.string().url().optional(),
    durationSeconds: zod_1.z.number().int().positive().optional(),
    locationIds: zod_1.z.array(zod_1.z.string()).default([]),
    displayIds: zod_1.z.array(zod_1.z.string()).default([]),
    schedule: zod_1.z.object({
        startDate: zod_1.z.number(),
        endDate: zod_1.z.number(),
        daysOfWeek: zod_1.z.array(zod_1.z.number().int().min(0).max(6)).optional(),
        startTime: zod_1.z.string().regex(/^\d{2}:\d{2}$/).optional(),
        endTime: zod_1.z.string().regex(/^\d{2}:\d{2}$/).optional(),
    }).optional(),
    impressionCount: zod_1.z.number().int().nonnegative().default(0),
    clickCount: zod_1.z.number().int().nonnegative().default(0),
    budget: zod_1.z.number().nonnegative().optional(),
    costPerImpression: zod_1.z.number().nonnegative().optional(),
    totalSpent: zod_1.z.number().nonnegative().default(0),
    status: exports.APosAdStatusSchema.default('draft'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosAdvertisementCreateInputSchema = zod_1.z.object({
    advertiserId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    description: zod_1.z.string().max(500).optional(),
    adType: exports.APosAdTypeSchema,
    mediaUrl: zod_1.z.string().url(),
    mediaKey: zod_1.z.string().optional(),
    thumbnailUrl: zod_1.z.string().url().optional(),
    clickUrl: zod_1.z.string().url().optional(),
    durationSeconds: zod_1.z.number().int().positive().optional(),
    locationIds: zod_1.z.array(zod_1.z.string()).optional(),
    displayIds: zod_1.z.array(zod_1.z.string()).optional(),
    schedule: exports.APosAdvertisementSchema.shape.schedule,
    budget: zod_1.z.number().nonnegative().optional(),
    costPerImpression: zod_1.z.number().nonnegative().optional(),
});
exports.APosAdvertisementUpdateInputSchema = exports.APosAdvertisementCreateInputSchema.partial().extend({
    status: exports.APosAdStatusSchema.optional(),
});
//# sourceMappingURL=advertisement.schema.js.map